module.exports = __webpack_public_path__ + "img/pos-order.00be62d2.svg";